import type { DocMigration } from "../docMigration";

const NONE_OPTION_ID_SUFFIX = "_NONE";
const OPTION_SET_ID_PREFIX = "param_";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_219: DocMigration = {
  maxSchemaVersion: "0.0.219",
  description: "Correct the option ID value for NONE Options",
  apply(json: any) {
    if (!json.optionSets) {
      json.optionSets = {};
    }

    const updatedOptionSets = {};

    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];

      // Ignore toggle Option Sets
      if (Object.keys(optionSet.options ?? {}).every((key) => ["true", "false"].includes(key))) {
        updatedOptionSets[optionSetId] = optionSet;
        continue;
      }

      const updatedOptions = {};

      for (const optionId in optionSet.options) {
        const option = optionSet.options[optionId];

        if (option.id?.endsWith(NONE_OPTION_ID_SUFFIX)) {
          const updatedId = option.id.startsWith(OPTION_SET_ID_PREFIX)
            ? option.id.replace(OPTION_SET_ID_PREFIX, "")
            : option.id;

          updatedOptions[updatedId] = {
            ...option,
            id: updatedId,
          };
        } else {
          updatedOptions[optionId] = option;
        }
      }

      updatedOptionSets[optionSetId] = {
        ...optionSet,
        options: updatedOptions,
      };
    }

    json.optionSets = updatedOptionSets;

    return json;
  },
};

export default migration_0_0_219;
